import mustache from "mustache";
import { BaseRequest } from "../../../../base/request/BaseRequest";
import { FormField } from "../../../base/form/FormField";
import { SwitchConfig } from "../../../definitions/form/inputs/config/SwitchConfig";
import { IInputSwitchField } from "../../../definitions/form/inputs/IInputSwitchField";
import template from "./template.html";

mustache.parse(template);

/** Campo switch (boolean) del sistema nuevo. Enlaza un boolean del request.
 *  Un switch siempre es válido (sin reglas de validación). */
export class InputSwitchField<TRequest extends BaseRequest>
  extends FormField<SwitchConfig<TRequest>>
  implements IInputSwitchField
{
  private readonly _request: TRequest;

  constructor(request: TRequest, config: SwitchConfig<TRequest>) {
    super(config);
    this._request = request;
  }

  private _onValueChange?: () => void;

  setOnChange(handler: () => void): void {
    this._onValueChange = handler;
  }

  /** Valor actual del switch (desde el request, fuente de verdad). */
  getValue(): boolean {
    return this._config.get(this._request);
  }

  getTemplate(): string {
    return template;
  }

  getData(): unknown {
    return {
      label: this._config.label,
      description: this._config.description ?? "",
      checked: this._config.get(this._request),
      id: this._formFieldId,
    };
  }

  connect(): void {
    this._input = document.getElementById(
      `input-${this._formFieldId}`,
    ) as HTMLInputElement;
    this._input?.addEventListener("change", this._onChange);
  }

  doDispose(): void {
    this._input?.removeEventListener("change", this._onChange);
  }

  /** Un switch siempre es válido. */
  getError(): string | null {
    return null;
  }

  showError(): void {}

  focus(): void {
    this._input?.focus();
  }

  disabled(): void {
    if (this._input) this._input.disabled = true;
  }

  enabled(): void {
    if (this._input) this._input.disabled = false;
  }

  private _input: HTMLInputElement | null = null;

  private _onChange = (): void => {
    if (!this._input) return;
    this._config.set(this._request, this._input.checked);
    this._onValueChange?.();
  };
}
